export interface SystemState {   
    showLoading: boolean;
    showError: boolean;
    messageResponse: MessageResponse | null;    
    messageErrorResponse: MessageResponse | null;    
    title:string;
    showWarningPopup:boolean;
    showMyUser:boolean;
  }



export interface MessageResponse{
    code: number,
    message : string [],
    process?: string
}

export const TOGGLE_LOADING_INDICATOR = "TOGGLE_LOADING_INDICATOR";
export const TOGGLE_ERROR_INDICATOR = "TOGGLE_ERROR_INDICATOR";
export const SET_MESSAGE_RESPONSE = 'SET_MESSAGE_RESPONSE';
export const SET_ERROR_MESSAGE_RESPONSE = 'SET_ERROR_MESSAGE_RESPONSE';
export const SET_WARNING_MESSAGE_RESPONSE_POPUP = 'SET_WARNING_MESSAGE_RESPONSE_POPUP';
export const SET_MY_USER = 'SET_MY_USER';

type AcceptedTypes =  typeof TOGGLE_LOADING_INDICATOR | typeof SET_MESSAGE_RESPONSE 
| typeof TOGGLE_ERROR_INDICATOR | typeof SET_ERROR_MESSAGE_RESPONSE | typeof SET_WARNING_MESSAGE_RESPONSE_POPUP | typeof SET_MY_USER

interface UpdateSessionAction {
    type: AcceptedTypes;
    payload: SystemState | boolean| string | MessageResponse ;
}

export type SystemActionTypes = UpdateSessionAction ;
